import $ from "jquery";
import block from 'block-ui'
import {isDarkThemeEnabled} from "@/helpers/darkThemeHelper";

export function blockUi(element, opacity = 0, message = '') {

    let backgroundColor = '#ffffff'

    $(element).block({
        message: message + '<div class="sk-wave sk-secondary mx-auto"><div class="sk-wave-rect"></div><div class="sk-wave-rect"></div><div class="sk-wave-rect"></div><div class="sk-wave-rect"></div><div class="sk-wave-rect"></div></div>',
        css: {
            backgroundColor: 'transparent',
            border: '0'
        },
        overlayCSS:  {
            backgroundColor: backgroundColor,
            opacity: opacity
        }
    });
}

export function unblockUi(element) {
    $(element).unblock();
}
